import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '../../core/services/auth.service';

@Injectable({providedIn: 'root'})
export class IntelligenceGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    let allowed = false;

    if (this.authService.isLoggedIn()) {
      allowed = (this.authService.userHasAnyRole(['WF_ADMIN', 'INTELLIGENCE_CHARTS', 'ALL']));
      if (!allowed) {
        this.router.navigate(['forbidden']);
      }
      return allowed;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
    return false;
  }
}
